let wsCount = 0
const wsParamName = 'filter'

const setText = (name: string, clicked?: boolean) => {
  if (clicked) {
    const listFilter = document.getElementById('listfilterid')
    listFilter?.classList.add('highlight')
    setTimeout(() => {
      listFilter?.classList.remove('highlight')
    }, 200)
  }

  const [singular] = document.getElementsByClassName('singular')
  const [plural] = document.getElementsByClassName('plural')

  if (wsCount === 1) {
    singular.classList.add('show')
    plural.classList.remove('show')
  } else {
    singular.classList.remove('show')
    plural.classList.add('show')
  }

  const [counter] = document.getElementsByClassName('listcount')
  const [nameslist] = document.getElementsByClassName('nameslist') as HTMLCollectionOf<HTMLElement>

  if (counter) {
    counter.innerHTML = String(wsCount)
  }

  const nameListArr = nameslist.innerText.split(',')
  const currentIndex = nameListArr.indexOf(name)

  if (currentIndex > -1) {
    nameListArr.splice(currentIndex, 1)
  } else {
    nameListArr.push(name)
  }

  nameslist.innerText = nameListArr.join(', ')
}

const insertParam = (value: string) => {
  const urlParams = new URLSearchParams(window.location.search)
  const params = urlParams.get(wsParamName) ?? ''
  const paramArr = params.split(',').filter(s => Boolean(s)) ?? []
  const currenParamIndex = paramArr.indexOf(value)

  if (currenParamIndex > -1) {
    paramArr.splice(currenParamIndex, 1)
  } else {
    paramArr.push(value)
  }

  const updatedParams = paramArr.length === 0 ? '' : `?${wsParamName}=${paramArr.join(',')}`

  const refresh = window.location.protocol + '//' + window.location.host + window.location.pathname + updatedParams
  window.history.pushState({ path: refresh }, '', refresh)
}

const handleToggleFilter = () => {
  const inputs = document.querySelectorAll('.substanceFilter input[type="checkbox"]') as NodeListOf<HTMLInputElement>

  inputs.forEach((input) => {
    const { id, value } = input

    input.addEventListener('change', () => {
      const infoItem = document.querySelector(`div[data-filterid="${value}"]`)

      if (!infoItem) return
      const isVisible = infoItem.classList.contains('show')

      if (isVisible) {
        infoItem.classList.remove('show')
        wsCount = Math.max(0, wsCount - 1)
        insertParam(id.toLowerCase())
      } else {
        infoItem.classList.add('show')
        wsCount++
        insertParam(id.toLowerCase())
      }

      setText(id, true)
    })
  })
}

const handleClearFilters = () => {
  const clearBtn = document.querySelector('.substanceFilter .clear')

  if (!(clearBtn instanceof HTMLElement)) return

  clearBtn.addEventListener('click', (e) => {
    e.preventDefault()
    const allCheckBoxes = document.querySelectorAll(
      '.substanceFilter input[type="checkbox"]',
    ) as NodeListOf<HTMLInputElement>
    allCheckBoxes.forEach((el) => {
      if (el.checked) {
        el.checked = false

        const change = new Event('change', { bubbles: true })
        el.dispatchEvent(change)
      }
    })
  })
}

const handleSelectAllFilters = () => {
  const clearBtn = document.querySelector('.substanceFilter .markall')

  if (!(clearBtn instanceof HTMLElement)) return

  clearBtn.addEventListener('click', (e) => {
    e.preventDefault()
    const allCheckBoxes = document.querySelectorAll(
      '.substanceFilter input[type="checkbox"]',
    ) as NodeListOf<HTMLInputElement>
    allCheckBoxes.forEach((el) => {
      if (!el.checked) {
        el.checked = true

        const change = new Event('change', { bubbles: true })
        el.dispatchEvent(change)
      }
    })
  })
}

const handleToggleParams = () => {
  const filterDisplay = document.querySelector('.substanceFilter')
  const filterContent = document.getElementById('filtercontentid')
  const toggle = document.querySelector('.substanceFilter .toggle')
  const icon = toggle?.querySelector('fa-plus')

  toggle?.addEventListener('click', (e) => {
    e.preventDefault()

    filterDisplay?.classList.toggle('closed')
    icon?.classList.toggle('fa-minus')

    if (toggle.getAttribute('aria-expanded') === 'true') {
      toggle.setAttribute('aria-label', 'Expandera')
      toggle.setAttribute('aria-expanded', 'false')
      filterContent?.setAttribute('aria-expanded', 'false')
    } else {
      toggle.setAttribute('aria-label', 'Minimera')
      toggle.setAttribute('aria-expanded', 'true')
      filterContent?.setAttribute('aria-expanded', 'true')
    }
  })
}

const setInitialChecks = () => {
  const checkedInputs = document.querySelectorAll(
    '.substanceFilter input[type="checkbox"]:checked',
  ) as NodeListOf<HTMLInputElement>

  checkedInputs.forEach(({ id, value }) => {
    const infoItem = document.querySelector(`div[data-filterid="${value}"]`)

    if (!infoItem) return
    const isVisible = infoItem.classList.contains('show')

    if (isVisible) {
      infoItem.classList.remove('show')
      wsCount = Math.max(0, wsCount - 1)
    } else {
      infoItem.classList.add('show')
      wsCount++
    }
    setText(id)
  })
}

const init = () => {
  setInitialChecks()
  handleToggleParams()
  handleToggleFilter()
  handleClearFilters()
  handleSelectAllFilters()
}

init()
